/**************************************************
 * Nombre:       Dialogo_Datos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Datos from "../Formularios/Formulario_Datos";
import {CheckCircle} from '@mui/icons-material'
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {actualizarDoc} from "../../Servicios/BD/actualizarDoc";
import {useEscogerFechaCita} from "../../Modulo_Citas/Hooks/useEscogerFechaCita";

const Dialogo_Datos_Cita = ({datos, cerrar, finalizar}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Tarjeta_Cita, fecha} = useEscogerFechaCita({coleccionCita: 'leads', colecionDiasDispo: 'diasDisponible'})
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logo,
        funcionUno: cerrar,
        funcionDos: finalizar
    })

    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        entidad.fecha = new Date().getTime()
        entidad.fechaCita = fecha
        entidad.estado = 'Nuevo'
        iniciarCarga('Subiendo datos')
        let dox = await guardarDoc('leads', entidad)
        await actualizarCupos(entidad.idLanding, entidad.cupos)

        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito, te enviaremos mas detalles'})
        } else {
            terminar({aviso: 'No se logro completar la tarea, intentalo nuevamente', variante: 'error'})
        }

    }

    const actualizarCupos = async (idLanding, cupos) => {
        await actualizarDoc('landings', idLanding, {cuposOcupados: cupos + 1})
    }


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Cargador/>

            <Avisos/>

            <Grid container size={10} justifyContent={'center'} sx={{mb: 2}}>
                <Typography sx={{fontSize: 24, fontWeight: 800, textAlign: 'center', lineHeight: 1.1}}>Agenda y
                    separa tu cupo hora!</Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Tarjeta_Cita/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                <Formulario_Datos props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'} sx={{mt: 4, mb: 2}}>
                <Button
                    onClick={() => subirDatos()}
                    startIcon={<CheckCircle sx={{mt: 0}}/>}
                    sx={{pt: 1.3, pb: 1.3, borderRadius: 6, fontSize: 16, px: 4}}>Separa mi cupo ahora</Button>
            </Grid>

        </Grid>
    )

}
export default Dialogo_Datos_Cita